module.exports = __webpack_public_path__ + "static/1-2c39239f9362c0281e221abce7bcd827.png";